<template>
  <div class="outer-wrapper">
    <div class="title-wrapper">
      <p>原始记录</p>
    </div>
    <van-tabs v-model="currentTab" @click="onTabsClick">
      <van-tab title="未上传" name="not">
        <van-search
          v-model="keyword"
          placeholder="请输入原始记录编号"
          input-align="center"
          @search="onSearch"
          v-show="false"
        />
        <van-list
          v-model="itemTable.loading"
          :finished="itemTable.finished"
          finished-text="没有更多了"
          :error.sync="itemTable.error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <van-cell
            v-for="(item, index) in itemTable.tivdata"
            :key="index + 'item'"
            :title="item.display_no"
            :label="item.task_info"
            @click="chooseItem(item)"
            is-link
          >
            <span class="cell-item" v-if="currentTab==='not'">{{
              item.create_time.split(" ")[0] + " "
            }}</span>
            <span class="cell-item">{{ item.stat }}</span>
            <template #label v-if="currentTab==='not'">
              <p v-for="(ele, i) in item.task_info.split('++')" :key="i">
                <span>{{ sampleDisplayNoAbbr(ele.split("|")[0]) }}</span
                >(<span>{{ ele.split("|")[1] }}</span
                >)
              </p>
            </template>
          </van-cell>
        </van-list>
      </van-tab>
      <van-tab title="已上传" name="yes">
        <van-search
          v-model="keyword"
          placeholder="请输入原始记录编号"
          input-align="center"
          @search="onSearch"
          v-show="false"
        />
        <van-list
          v-model="itemTable.loading"
          :finished="itemTable.finished"
          finished-text="没有更多了"
          :error.sync="itemTable.error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <van-cell
            v-for="(item, index) in itemTable.tivdata"
            :key="index + 'item'"
            :title="item.display_no"
            :label="item.task_info"
            @click="chooseItem(item)"
            is-link
          >
            <span class="cell-item" v-if="currentTab==='yes'">{{
              item.create_time.split(" ")[0] + " "
            }}</span>
            <span class="cell-item">{{ item.stat}}</span>
            <template #label v-if="currentTab==='yes'">
              <p v-for="(ele, i) in item.task_info.split('++')" :key="i">
                <span>{{ sampleDisplayNoAbbr(ele.split("|")[0]) }}</span
                >(<span>{{ ele.split("|")[1] }}</span
                >)
              </p>
            </template>
          </van-cell>
        </van-list>
      </van-tab>
      <van-tab title="待出具" name="null">
        <van-search
          v-model="keyword"
          placeholder="请输入原始记录编号"
          input-align="center"
          @search="onSearch"
          v-show="false"
        />
        <van-list
          v-model="itemTable.loading"
          :finished="itemTable.finished"
          finished-text="没有更多了"
          :error.sync="itemTable.error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
        <van-checkbox-group v-model="choosedTasks">
          <van-cell
              v-for="(item, index) in itemTable.tivdata"
              :key="index + 'su'"
              :title="item.name"
              :label="item.customer_sample_name+'('+sampleDisplayNoAbbr(item.customer_sample_display_no)+')'"
              is-link
            >
            <template #title>
               <van-checkbox :name="item.enid" shape="square"><span>{{item.name}}</span></van-checkbox>
            </template>
            <van-tag plain type="success" class="c-tag">{{item.test_category}}</van-tag>
              <span class="cell-item" @click="chooseMyTask(item)">{{item.stat}}</span>
            </van-cell>
            </van-checkbox-group>
        </van-list>
        <div class="submit-b-wrapper" v-show="itemTable.tivdata.length>0">
          <van-button type="info" class="submit-b" block @click="productRecord" :disabled="choosedTasks.length===0">生成原始记录单号</van-button>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
//let authData = JSON.parse(localStorage.getItem("authData"));
import { textTrans } from "@/mixins/TextTrans.js";

function itemTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

export default {
  name: "originRecord",
  components: {},
  mixins: [textTrans],
  data() {
    return {
      currentTab: 'not',
      itemTable: itemTableFac(),
      keyword: "",
      askData: "myOriginRecordList",
      choosedTasks:[]
    };
  },
  watch: {},
  computed: {},
  created() {
    this.onLoad();
  },
  methods: {
    onSearch() {
      this.itemTable = itemTableFac();
      this.onLoad();
    },
    onLoad() {
      this.itemTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.itemTable.Tpage,
          userToken: userToken,
          ask_data: this.askData,
          keyword: this.keyword,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            this.itemTable.tivdata.push(ele);
          }
          console.log(this.itemTable.tivdata);
          if (
            response.data.res_record.length < this.itemTable.Tpage.currentSize
          ) {
            this.itemTable.finished = true;
          }
          this.itemTable.loading = false;
          this.itemTable.Tpage.currentPage++;
        });
    },
    chooseItem(val) {
      window.location.href = "/originRecordOp/" + val.id;
    },
    onTabsClick(val) {
      if (val === "not") {
        this.askData = "myOriginRecordList";
      } else if(val==='yes'){
        this.askData = "myUploadedOriginRecordList";
      }else if(val==='null'){
        this.askData = "myTaskWithoutRecordList";
      }
      this.onSearch();
    },
    chooseMyTask(val) {
      window.location.href = '/task/'+val.enid;
    },
    productRecord(){
      if(this.choosedTasks.length>0){
        this.spin = true;
        this.$axios
            .post(this.$url + "/inspection_do", {
            userToken: userToken,
            tasks:this.choosedTasks,
            ask_data: "productRecordForTaskWithoutRecord",
            })
            .then(response => {
            if(response.data.stat==='ok'){
              this.$dialog.alert({
                title: '操作成功',
                message: '原始记录编号为:'+response.data.record,
              }).then(() => {
                this.onSearch();
              });
               
            }else{
                this.$toast.fail('操作失败！请确认选择了相同检测类别的试验！');
            }
            });
      }
    },
  },
};
</script>
<style scoped>
.title-wrapper {
  color: #666;
  font-size: 0.8rem;
  text-align: center;
  margin: 0.8rem 0 0rem;
}

.submit-b-wrapper{
  position: fixed;
  bottom:0;
  width:100%;
}

.c-tag{
  margin: 0 0.6rem;
}
</style>